"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateGroup = exports.getGroupMaxMin = exports.allGroupsValid = exports.isGroupValid = exports.getAddonPrice = exports.getAddonGroupName = exports.getAddonName = exports.isAddonGroups = void 0;
const products_1 = require("./products");
/**
 * Return if product is addon groups type (it has priority over addons)
 * @param  {Product} product - product obj
 * @returns {boolean} true if it is an addonGroups product
 */
const isAddonGroups = (product) => {
    return !(0, products_1.hasAddons)(product) && (0, products_1.hasAddonGroups)(product);
};
exports.isAddonGroups = isAddonGroups;
/**
 * Return addon's name translated (if it has translation) or the default addon name
 * @param  {Addon} addon - addon obj
 * @param  {string} language - language to be translated
 * @returns {string} translated addon name
 */
const getAddonName = (addon, language = 'en') => {
    if (!!addon.translations && !!addon.translations.names) {
        return !!addon.translations.names[language] ? addon.translations.names[language] : addon.name;
    }
    return addon.name;
};
exports.getAddonName = getAddonName;
/**
 * Return addonGroup's name translated (if it has translation) or the default addonGroup name
 * @param  {AddonGroup} group - addonGroup obj
 * @param  {string} language - language to be translated
 * @returns {string} translated AddonGroup name
 */
const getAddonGroupName = (group, language = 'en') => {
    if (!!group._id.translations && !!group._id.translations.names) {
        return !!group._id.translations.names[language]
            ? group._id.translations.names[language]
            : group._id.name;
    }
    return group._id.name;
};
exports.getAddonGroupName = getAddonGroupName;
/**
 * Return addon price (sale/cost)
 * @param  {Addon} addon - addon obj
 * @param  {string} storeId - [optional] store id
 * @param  {string} type - 'price' or 'cost_price'
 * @returns {number} addon price
 */
const getAddonPrice = (addon, storeId, type = 'price') => {
    if (addon.local_prices && addon.local_prices.length) {
        const priceIndex = addon.local_prices.findIndex((local) => local.store === storeId);
        if (priceIndex >= 0) {
            return addon.local_prices[priceIndex][type] ? addon.local_prices[priceIndex][type] : 0;
        }
    }
    const result = type === 'price' ? addon.price : addon.cost_price;
    return !!result ? result : 0;
};
exports.getAddonPrice = getAddonPrice;
/**
 * Check if addon group has all mandatory fields
 * @param  {AddonGroup} group - Addon group obj
 * @returns {boolean} return true if group can be used
 */
const isGroupValid = (group) => {
    return !!group._id && !!group._id.addons && !!group._id.addons.length;
};
exports.isGroupValid = isGroupValid;
/**
 * Check if all addon groups are valid
 * @param  {Product} product - Product obj
 * @returns {boolean} return true if all groups can be used
 */
const allGroupsValid = (product) => {
    return product.addonGroups.map((group) => (0, exports.isGroupValid)(group)).every((valid) => !!valid);
};
exports.allGroupsValid = allGroupsValid;
/**
 * Return the max||min group amount
 * @param  {AddonGroup} group - Addon group obj
 * @param  {string} type - max or min
 * @returns {number} Number that can validade current addons list
 */
const getGroupMaxMin = (group, type) => {
    var _a;
    const maxMin = type === 'max' ? 'max' : 'min';
    // Need zero check because if !!group[type] will return false
    if (!!group[maxMin] || group[maxMin] === 0) {
        return (_a = group[maxMin]) !== null && _a !== void 0 ? _a : 0;
    }
    const defaultMaxMin = type === 'max' ? 'default_max' : 'default_min';
    if (!!group._id[defaultMaxMin]) {
        return group._id[defaultMaxMin];
    }
    return 0;
};
exports.getGroupMaxMin = getGroupMaxMin;
/** Check if addons in the list follow group max/min rule
 * @param  {any[]} list - List if all addons that was attached to the product (object is {...addon, amount: x})
 * @param  {AddonGroup} group - Addon group to be validate
 * @returns {boolean} Returns true if list follow group max/min rule
 */
const validateGroup = (list, group) => {
    const max = (0, exports.getGroupMaxMin)(group, 'max');
    const min = (0, exports.getGroupMaxMin)(group, 'min');
    const sum = list.reduce((acc, addon) => acc + addon.amount, 0);
    return sum <= max && sum >= min;
};
exports.validateGroup = validateGroup;
